<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [style]="{ width: '640px', maxWidth: '95vw' }"
  [header]="
    displayNote?.id ? (canEdit ? 'Edit Client Note' : 'View Client Note') : 'New Client Note'
  "
  (onHide)="closed.emit()"
>
  <div *ngIf="displayNote" class="modal-body">
    <!-- Type -->
    <div class="row m-b-10">
      <div class="col-xs-4 bold">Type</div>
      <div class="col-xs-8">
        <select
          *ngIf="canEdit"
          class="form-control"
          [(ngModel)]="displayNote.type"
          (ngModelChange)="onNoteTypeChange()"
        >
          <option *ngFor="let t of noteTypes" [value]="t">{{ t }}</option>
        </select>
        <span *ngIf="!canEdit">{{ displayNote.type }}</span>
      </div>
    </div>
    <!-- Status -->
    <div class="row m-b-10">
      <div class="col-xs-4 bold">Status</div>
      <div class="col-xs-8">
        <select *ngIf="canEdit" class="form-control" [(ngModel)]="displayNote.status">
          <option *ngFor="let s of noteStatuses" [value]="s">{{ s }}</option>
        </select>
        <span *ngIf="!canEdit">{{ displayNote.status }}</span>
      </div>
    </div>
    <!-- Resource Request fulfillment -->
    <div class="row m-b-10" *ngIf="isResourceRequest(displayNote)">
      <div class="col-xs-4 bold">Fulfillment</div>
      <div class="col-xs-8">
        <select
          *ngIf="canEdit"
          class="form-control"
          [(ngModel)]="displayNote.resourceRequestStatus"
        >
          <option value="">--Select--</option>
          <option *ngFor="let s of resourceRequestStatusOptions" [value]="s">{{ s }}</option>
        </select>
        <span *ngIf="!canEdit">{{ displayNote.resourceRequestStatus || "-" }}</span>
      </div>
    </div>
    <!-- Client -->
    <div class="row m-b-10">
      <div class="col-xs-4 bold">Client</div>
      <div class="col-xs-8">
        <select
          *ngIf="canEdit && !displayNote?.id"
          class="form-control"
          [(ngModel)]="displayNote.clientId"
          (ngModelChange)="onClientChange()"
        >
          <option value="">--Select Client--</option>
          <option *ngFor="let c of clients" [value]="c.id">{{ c.companyName }}</option>
        </select>
        <span *ngIf="!canEdit || displayNote?.id">{{ displayNote.clientName || "-" }}</span>
      </div>
    </div>
    <!-- Scheduled outage range + scheduling groups -->
    <ng-container *ngIf="isScheduledOutage(displayNote)">
      <div class="row m-b-10">
        <div class="col-xs-4 bold">Outage Dates</div>
        <div class="col-xs-8">
          <div *ngIf="canEdit" class="outage-dates">
            <p-calendar
              [(ngModel)]="displayNote.startDate"
              dateFormat="mm/dd/yy"
              [showIcon]="true"
              [showOnFocus]="false"
              [appendTo]="'body'"
              styleClass="outage-calendar"
              ariaLabel="Outage start date"
            ></p-calendar>
            <span class="outage-dates-sep">to</span>
            <p-calendar
              [(ngModel)]="displayNote.endDate"
              dateFormat="mm/dd/yy"
              [showIcon]="true"
              [showOnFocus]="false"
              [appendTo]="'body'"
              styleClass="outage-calendar"
              ariaLabel="Outage end date"
            ></p-calendar>
          </div>
          <span *ngIf="!canEdit"
            >{{ toDisplayDate(displayNote.startDate) | date: "MM/dd/yyyy" }} to
            {{ toDisplayDate(displayNote.endDate) | date: "MM/dd/yyyy" }}</span
          >
        </div>
      </div>
      <div class="row m-b-10">
        <div class="col-xs-4 bold">Groups</div>
        <div class="col-xs-8">
          <div *ngIf="canEdit" class="outage-group-list">
            <div *ngIf="schedulingTeamsLoading" class="text-muted">
              <i class="fa fa-spinner fa-spin"></i> Loading scheduling groups...
            </div>
            <div
              *ngIf="!schedulingTeamsLoading && schedulingTeamsForClient.length === 0"
              class="text-muted"
            >
              This client has no scheduling groups.
            </div>

            <ng-container *ngIf="!schedulingTeamsLoading && schedulingTeamsForClient.length > 0">
              <label class="outage-group-item outage-group-item-all">
                <input
                  type="checkbox"
                  [checked]="allOutageTeamsSelected"
                  [indeterminate]="someOutageTeamsSelected"
                  (change)="toggleAllOutageTeams($event)"
                />
                <span>Select all</span>
              </label>
              <div class="outage-group-divider"></div>
            </ng-container>

            <label *ngFor="let team of schedulingTeamsForClient" class="outage-group-item">
              <input
                type="checkbox"
                [checked]="isOutageTeamSelected(team.id)"
                (change)="toggleOutageTeam(team.id)"
              />
              <span>{{ team.name }}</span>
            </label>
          </div>
          <span *ngIf="!canEdit">{{ outageGroupNames || "-" }}</span>
        </div>
      </div>
    </ng-container>
    <!-- Follow Up Date -->
    <div class="row m-b-10">
      <div class="col-xs-4 bold">Follow Up</div>
      <div class="col-xs-8">
        <p-calendar
          *ngIf="canEdit"
          [(ngModel)]="displayNote.followUpDate"
          dateFormat="mm/dd/yy"
          [showIcon]="true"
          [showOnFocus]="false"
          [showTime]="false"
          [appendTo]="'body'"
          styleClass="followup-calendar"
          ariaLabel="Follow up date"
        ></p-calendar>
        <span *ngIf="!canEdit">{{
          displayNote.followUpDate ? (displayNote.followUpDate | date: "MM/dd/yyyy") : "-"
        }}</span>
      </div>
    </div>
    <!-- Date -->
    <div class="row m-b-10">
      <div class="col-xs-4 bold">Date</div>
      <div class="col-xs-8">{{ displayNote.dateCreatedUtc | date: "MM/dd/yyyy HH:mm" }}</div>
    </div>
    <!-- Created By -->
    <div class="row m-b-10" *ngIf="displayNote.createdByUserName">
      <div class="col-xs-4 bold">Created By</div>
      <div class="col-xs-8">{{ displayNote.createdByUserName }}</div>
    </div>
    <!-- Note -->
    <div class="m-t-15">
      <div class="bold m-b-5">Note <span *ngIf="canEdit" class="text-danger">*</span></div>
      <textarea
        *ngIf="canEdit"
        class="form-control"
        [(ngModel)]="displayNote.note"
        rows="6"
        placeholder="Enter note text..."
      ></textarea>
      <div
        *ngIf="!canEdit"
        style="
          white-space: pre-wrap;
          background: #f9f9f9;
          border: 1px solid #e5e5e5;
          border-radius: 4px;
          padding: 12px;
          min-height: 80px;
        "
      >
        {{ displayNote.note }}
      </div>
    </div>

    <!-- Status Updates: only a saved note can carry them -->
    <div *ngIf="displayNote.id" class="note-updates-block m-t-15">
      <h5 class="section-header">
        Status Updates
        <span *ngIf="hasUpdates" class="badge badge-secondary update-count-badge">
          {{ displayNote.updates?.length }}
        </span>
      </h5>

      <div *ngIf="hasUpdates" class="note-updates-list">
        <div *ngFor="let update of displayNote.updates" class="note-update-item">
          <div class="note-update-head">
            <span class="note-update-label">{{ update.label || "Update" }}</span>
            <span class="note-update-meta">
              {{ formatUpdateDate(update.dateCreatedUtc) }}
              <ng-container *ngIf="update.createdByUserName">
                &middot; {{ update.createdByUserName }}
              </ng-container>
              <i
                *ngIf="update.emailedToClient"
                class="fa fa-envelope text-success ml-1"
                title="Emailed to client"
              ></i>
            </span>
          </div>
          <div *ngIf="update.internalNotes" class="note-update-text note-update-internal">
            <span class="note-update-tag">Internal</span>
            {{ update.internalNotes }}
          </div>
          <div *ngIf="update.clientNotes" class="note-update-text note-update-client">
            <span class="note-update-tag">Public</span>
            {{ update.clientNotes }}
          </div>
          <div class="note-update-actions" *ngIf="canEdit">
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm"
              (click)="startEditUpdate(update)"
              title="Edit update"
            >
              <i class="fa fa-pencil"></i> Edit
            </button>
            <button
              type="button"
              class="btn btn-info btn-sm"
              (click)="emailUpdateToClient(update)"
              title="Email this update to the client"
            >
              <i class="fa fa-envelope"></i> Email Client
              <i class="fa fa-check text-success ml-1" *ngIf="update.emailedToClient"></i>
            </button>
            <button
              type="button"
              class="btn btn-outline-danger btn-sm"
              (click)="deleteUpdate(update)"
              title="Delete update"
            >
              <i class="fa fa-trash"></i> Delete
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="!hasUpdates && canEdit" class="text-muted small m-b-10">No updates yet.</div>

      <button
        *ngIf="canEdit && !showAddUpdate"
        type="button"
        class="btn btn-outline-secondary btn-sm"
        (click)="openAddUpdate()"
      >
        <i class="fa fa-plus"></i> Add Update
      </button>

      <div *ngIf="canEdit && showAddUpdate" class="note-update-add">
        <h6 class="text-muted" *ngIf="editingUpdateId">Edit Update</h6>
        <div class="form-group">
          <label>Update Label (optional)</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="addUpdate.label"
            placeholder="e.g. Called customer, Waiting on reply"
          />
        </div>
        <div class="form-group">
          <label>Internal Notes</label>
          <textarea
            class="form-control"
            [(ngModel)]="addUpdate.internalNotes"
            rows="2"
            placeholder="Internal only - never leaves LGT"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Public Notes</label>
          <textarea
            class="form-control"
            [ngClass]="{ 'is-invalid': updateAttemptedSubmit && !isAddUpdateValid() }"
            [(ngModel)]="addUpdate.clientNotes"
            rows="2"
            placeholder="Can be emailed to the client"
          ></textarea>
        </div>
        <div class="button-group">
          <button type="button" class="btn btn-secondary btn-sm" (click)="cancelAddUpdate()">
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            (click)="saveUpdate()"
            [disabled]="isSavingUpdate"
          >
            <i class="fa fa-spin fa-spinner" *ngIf="isSavingUpdate"></i>
            {{ isSavingUpdate ? "Saving…" : editingUpdateId ? "Save Changes" : "Save Update" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <button class="btn btn-secondary m-r-5" (click)="closeModal()">
      {{ canEdit ? "Cancel" : "Close" }}
    </button>
    <button
      *ngIf="canEdit && canEmailClient()"
      class="btn btn-info ml-2"
      (click)="openEmailClient()"
      title="Email this note to the client"
    >
      <i class="fa fa-envelope"></i> Email Client
    </button>
    <button
      *ngIf="canEdit"
      class="btn btn-primary ml-2"
      (click)="saveNote()"
      [disabled]="saving || !displayNote?.clientId || !displayNote?.note?.trim()"
    >
      {{ saving ? "Saving…" : displayNote?.id ? "Update Note" : "Add Note" }}
    </button>
  </p-footer>
</p-dialog>

<!-- Email the note to the client -->
<p-dialog
  [(visible)]="showEmailCompose"
  [modal]="true"
  [style]="{ width: '600px', maxWidth: '95vw' }"
  header="Email Client"
  [closable]="false"
  styleClass="client-note-email-dialog"
>
  <div class="modal-body">
    <div class="form-group">
      <label>To</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="emailPreview.to"
        placeholder="(client email)"
      />
      <div class="text-danger m-t-5" *ngIf="emailValidationError">{{ emailValidationError }}</div>
    </div>
    <div class="form-group">
      <label>CC</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="emailPreview.ccEmails"
        placeholder="Separate multiple emails with semicolons"
      />
    </div>
    <div class="form-group">
      <label>Subject</label>
      <input type="text" class="form-control" [(ngModel)]="emailPreview.subject" />
    </div>
    <div class="form-group">
      <label>Message</label>
      <textarea class="form-control" rows="8" [(ngModel)]="emailPreview.body"></textarea>
    </div>

    <!-- Self-service signature editor (every email carries the signature) -->
    <div class="form-group">
      <div class="signature-edit-row">
        <label><strong>Your email signature</strong></label>
        <button type="button" class="btn btn-link btn-sm p-0" (click)="toggleSignatureEditor()">
          {{ showSignatureEditor ? "Hide" : "Change signature" }}
        </button>
      </div>
      <div
        class="signature-preview small text-muted"
        *ngIf="!showSignatureEditor && userEmailSignature"
      >
        {{ userEmailSignature }}
      </div>
      <div *ngIf="showSignatureEditor" class="signature-editor">
        <textarea
          rows="4"
          class="form-control"
          [(ngModel)]="signatureEditText"
          placeholder="Your email signature (one line per field / company / phone)"
        ></textarea>
        <div class="signature-edit-actions">
          <button
            class="btn btn-primary btn-sm"
            (click)="saveSignature()"
            [disabled]="savingSignature"
          >
            <i class="fa fa-spin fa-spinner" *ngIf="savingSignature"></i> Save signature
          </button>
          <span class="text-muted small ml-2"
            >Saved to your profile and used on all future emails.</span
          >
        </div>
        <div
          *ngIf="signatureSaveMessage"
          class="small mt-1"
          [class.text-success]="!signatureSaveError"
          [class.text-danger]="signatureSaveError"
        >
          {{ signatureSaveMessage }}
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <button class="btn btn-secondary" (click)="cancelEmailCompose()" [disabled]="emailSending">
      Cancel
    </button>
    <button
      class="btn btn-primary ml-2"
      (click)="confirmSendEmail()"
      [disabled]="emailSending || !emailPreview.to || !emailPreview.subject || !emailPreview.body"
    >
      <i class="fa fa-spinner fa-spin" *ngIf="emailSending"></i>
      <i class="fa fa-paper-plane" *ngIf="!emailSending"></i>
      {{ emailSending ? "Sending..." : "Send Email" }}
    </button>
  </p-footer>
</p-dialog>
